// eslint-disable-next-line consistent-default-export-name/default-export-match-filename
const TYPES = {
  //LOGOUT: 'LOGOUT',
  // LOGIN: 'LOGIN',
  // SIGNUP: 'SIGNUP',
  //FORGOT_PWD: 'FORGOT_PWD',
  //CHANGE_PWD: 'CHANGE_PWD',
  //VERIFY_EMAIL: 'VERIFY_EMAIL',

  SEND_USER_LOG: "SEND_USER_LOG",
  SET_AUTH_IS_CHECK: "SET_AUTH_IS_CHECK",
  SET_USER: "SET_USER",
  SET_JWT: "SET_JWT",

  SET_LANG: "SET_LANG",

  SET_TOAST: "SET_TOAST",
  GET_GLOBALS: "GET_GLOBALS",
  SET_SELECTED_DAY: "SET_SELECTED_DAY",
  SET_SELECTED_CATEGORY: "SET_SELECTED_CATEGORY",
  SET_LOCATION: "SET_LOCATION",
  SET_MAP_BOUNDS: "SET_MAP_BOUNDS",
  SET_SELECTED_EVENT: "SET_SELECTED_EVENT",

  //GET_ME: 'GET_ME',
  GET_SEARCH_EVENTS: "GET_SEARCH_EVENTS",
  GET_EVENT_BY_HANDLE_OR_UUID: "GET_EVENT_BY_HANDLE_OR_UUID",

  GET_FEATURED_EVENTS: 'GET_FEATURED_EVENTS',

  GET_MY_FAVORITE_EVENTS: "GET_MY_FAVORITE_EVENTS",
  GET_MY_EVENTS: "GET_MY_EVENTS",
  MAKE_EVENT_FAVORITE: "MAKE_EVENT_FAVORITE",
  REMOVE_EVENT_FAVORITE: "REMOVE_EVENT_FAVORITE",
  GET_MY_EVENT_COUNT_CREATED: "GET_MY_EVENT_COUNT_CREATED",
  CREATE_EVENT: "CREATE_EVENT",
  UPDATE_EVENT: "UPDATE_EVENT",
  DELETE_EVENT: "DELETE_EVENT",

  GET_MY_PAYMENT_METHODS: "GET_MY_PAYMENT_METHODS",
  GET_MY_INVOICES: "GET_MY_INVOICES",
  GET_MY_SUBSCRIPTION: "GET_MY_SUBSCRIPTION",


  ADMIN_GET_EVENTS: "ADMIN_GET_EVENTS",
  ADMIN_GET_EVENT_BY_UUID: "ADMIN_GET_EVENT_BY_UUID",
  ADMIN_CREATED_EVENT: "ADMIN_CREATED_EVENT",
  ADMIN_UPDATED_EVENT: "ADMIN_UPDATED_EVENT",
  ADMIN_DELETED_EVENT: "ADMIN_DELETED_EVENT",

  ADMIN_GET_USERS: "ADMIN_GET_USERS",
  ADMIN_GET_USER_BY_ID: "ADMIN_GET_USER_BY_ID",
  ADMIN_CREATED_USER: "ADMIN_CREATED_USER",
  ADMIN_UPDATED_USER: "ADMIN_UPDATED_USER",
  ADMIN_DELETED_USER: "ADMIN_DELETED_USER",

  ADMIN_GET_PUSH_LOGS: "ADMIN_GET_PUSH_LOGS",
  ADMIN_GET_PUSH_RECIPIENTS: "ADMIN_GET_PUSH_RECIPIENTS"


};

export default TYPES;
